<template>
    <div>
        <!--Row 4 : Etes-vous frontalier + Activité 100%-->
        <div class="row clearfix">
            <div class="col-md-6 column">
                <!-- Etes vous frontalier ou résident-->
                <div class="form-group required" :class="{'has-error': errors.has('typeResident')}">
                    <label class="form-label">{{$t('Bareme.etape1.champs.etesVousFrontalier')}}</label>
                    <div role="radio" class="radio" v-for="(tp, index) in listeReference.typeResident" v-bind:key="tp.value">
                        <label>
                            <input type="radio" :id="bind('typeResident',index)" name="typeResident" v-model="dossier.typeResident" v-validate="'required'"
                                      :value="{value: tp.value, description: tp.description}"
                                     :aria-label="tp.description"
                                     @change="onChangeTypeResident($event)">{{tp.description}}
                        </label>
                    </div>
                    <span v-if="submitted && errors.has('typeResident')" class="text-danger">{{ errors.first('typeResident') }}</span>
                </div>
            </div>
            <div class="col-md-6 column">
                <!-- Percevez-vous un revenu d’un seul employeur (en Suisse ou à l’étranger) -->
                <div class="form-group required" :class="{'has-error': errors.has('isRevenuUnSeulEmployeur')}">
                    <label class="form-label">{{$t('Bareme.etape1.champs.revenuSeulEmployeur')}}</label>
                    <div class="radio" >
                        <label v-tooltip="{content: getTooltip('Bareme.tooltip.titre.sourceRevenu','Bareme.tooltip.contenu.sourceRevenu')
                        , trigger: 'hover', placement: tooltipPlacement}">
                            <input type="radio" v-bind:value="true" name="isRevenuUnSeulEmployeur" v-validate="'required'"
                                   v-model="dossier.isRevenuUnSeulEmployeur" :aria-label="$t('general.oui')">{{$t('general.oui')}}</label>
                    </div>
                    <div class="radio" >
                        <label v-tooltip="{content: getTooltip('Bareme.tooltip.titre.sourceRevenu','Bareme.tooltip.contenu.sourceRevenu') ,
                        trigger: 'hover', placement: tooltipPlacement}">
                            <input type="radio" v-bind:value="false" name="isRevenuUnSeulEmployeur"
                                   v-model="dossier.isRevenuUnSeulEmployeur" :aria-label="$t('general.non')">{{$t('general.non')}}</label>
                    </div>
                    <span v-if="submitted && errors.has('isRevenuUnSeulEmployeur')" class="text-danger">{{ errors.first('isRevenuUnSeulEmployeur') }}</span>
                </div>
            </div>
        </div>

        <div class="row clearfix">
            <div class="col-md-6 column" v-if="isTypeResidentSuisseHorsGeneve">
                <!-- Canton-->
                <div class="form-group required" :class="{'has-error': errors.has('canton')}">
                    <label for="canton" class="form-label">{{$t('Bareme.etape1.champs.canton')}}</label>
                    <select class="form-control" v-model="dossier.canton" v-validate="'required'"
                            name="canton" id="canton">
                        <option v-for="canton in listeReference.cantons" v-bind:key="canton.code"
                                :value="{code: canton.code, label: canton.label}">{{canton.label}}
                        </option>

                    </select>
                    <span v-if="submitted && errors.has('canton')" class="text-danger">{{ errors.first('canton') }}</span>
                </div>
            </div>
            <div class="col-md-6 column">
                <!-- Quel est le taux global de toutes vos activités réunies (en Suisse et à l'étranger) ?  -->
                <div v-if="isAfficherTauxGlobalActivite" class="form-group required" :class="{'has-error': errors.has('tauxGlobalActivite')}">
                    <label for="tauxGlobalActivite" class="form-label required">{{$t('Bareme.etape1.champs.tauxGlobalActivite')}}</label>
                    <input type="number"
                           v-model="dossier.tauxGlobalActivite"
                           class="form-control"
                           id="tauxGlobalActivite"
                           v-validate="'required|min_value:10|max_value:200|numeric'"
                           name="tauxGlobalActivite"
                           v-tooltip="{content: getTooltip('Bareme.tooltip.titre.tauxActiviteGlobal','Bareme.tooltip.contenu.tauxActiviteGlobal'), placement: tooltipPlacement }"
                           >
                    <span v-if="submitted && errors.has('tauxGlobalActivite')" class="text-danger">{{ errors.first('tauxGlobalActivite') }}</span>
                </div>
            </div>

        </div>
        <!--Row 5 : Etat civil + Date changement Etat Civil -->
        <div class="row clearfix">
            <div class="col-md-6 column">

                <!-- Etat Civil-->
                <div class="form-group required" :class="{'has-error': errors.has('etatCivil')}">
                    <label for="etatCivil" class="form-label">{{$t('Bareme.etape1.champs.etatCivil')}}</label>
                    <select class="form-control" v-model="dossier.etatCivil" @change="onChange($event)" v-validate="'required'"
                            name="etatCivil" id="etatCivil">
                        <option v-for="ec in listeReference.etatCivil" v-bind:key="ec.value"
                                :value="{value: ec.value, description: ec.description, code: ec.code}">{{ec.description}}
                        </option>

                    </select>
                    <span v-if="submitted && errors.has('etatCivil')" class="text-danger">{{ errors.first('etatCivil') }}</span>
                </div>

            </div>
            <div class="col-md-6 column">
                <!-- Date changement Etat Civil-->
                <div v-if="isAfficherDateChangementEtatCivil" class="form-group" :class="{'has-error': errors.has('dateChangementEtatCivil')}">
                  <label for="dateChangementEtatCivil" class="form-label">{{$t('Bareme.etape1.champs.dateChangementEtatCivil')}}</label>
                  <DatePicker name="dateChangementEtatCivil"
                                       id="dateChangementEtatCivil"
                                       :iid="'dateChangementEtatCivil'"
                                       v-model="dossier.dateChangementEtatCivil"
                                       v-validate="'ruleDateChangementEtatCivil'">
                  </DatePicker>
                    <span v-if="submitted && errors.has('dateChangementEtatCivil')" class="text-danger">{{ errors.first('dateChangementEtatCivil') }}</span>
                </div>

            </div>
        </div>

        <!--Row 6 : Enfants à charge -->
        <div class="row clearfix">
            <div class="col-md-6 column">
                <!--Enfant à charge-->
                <div class="form-group required" :class="{'has-error': errors.has('hasEnfants')}">
                    <label class="form-label">{{$t('Bareme.etape1.champs.enfantsACharge')}} </label>
                    <div class="radio">
                        <label v-tooltip="{content: getTooltipAvecOptions('Bareme.tooltip.titre.enfantsACharge',
                                             'Bareme.tooltip.contenu.enfantsACharge', null,
                                             {annee: dossier.periodeFiscale, url: 'https://www.ge.ch/c/imp-lsdir'}),
                                      trigger: 'hover', placement: tooltipPlacement}">
                            <input type="radio" v-bind:value="true" name="hasEnfants" v-validate="'required'" v-model="dossier.hasEnfants" :aria-label="$t('general.oui')">
                            {{$t('general.oui')}}
                        </label>
                    </div>
                    <div class="radio">
                        <label v-tooltip="{content: getTooltipAvecOptions('Bareme.tooltip.titre.enfantsACharge',
                        'Bareme.tooltip.contenu.enfantsACharge', null, {annee: dossier.periodeFiscale, url: 'https://www.ge.ch/c/imp-lsdir'}),
                                      trigger: 'hover', placement: tooltipPlacement}">
                            <input type="radio" v-bind:value="false" name="hasEnfants" v-model="dossier.hasEnfants"
                                   @change="onChangeHasEnfants($event)" :aria-label="$t('general.non')">{{$t('general.non')}}</label>
                    </div>
                    <span v-if="submitted && errors.has('hasEnfants')" class="text-danger">{{ errors.first('hasEnfants') }}</span>
                </div>
            </div>
            <div class="col-md-6 column">

                <div v-if="dossier.hasEnfants" class="form-group required" >
                    <label class="form-label">{{$t('Bareme.etape1.champs.dateNaissanceEnfants')}} </label>
                    <div class="form-group required" v-for="dt in dossier.datesNaissanceEnfants"
                         v-bind:key="dt.id">
                        <div class="row">
                            <div class="col-md-6 col-xs-6 ">
                                <div class="input-group">
                                  <DatePicker :name="bindName(dt.id)"
                                              :tooltip-content="getTooltipAvecOptions('Bareme.tooltip.titre.dateNaissanceEnfants',
                                           'Bareme.tooltip.contenu.anneeNaissanceEnfants', null,
                                           {annee: dossier.periodeFiscale, url: 'https://www.ge.ch/c/imp-lsdir'})"
                                              :tooltip-placement="tooltipPlacement"
                                              :ref="'datesNaissanceEnfants'"
                                              v-model="dt.dateNaissance"
                                              v-validate="`required|ruleNbEnfants|agexMax25ALaFinDuMois`">
                                  </DatePicker>

                                    <!--bouton suppression année-->
                                    <span class="input-group-addon" :class="{'fa-disabled' : (dt.id == 1)}"
                                          @click="deleteAnnee(dt.id)" v-on:keyup.enter="deleteAnnee(dt.id)" tabindex="0">
                                        <i class="fa fa-trash" style="cursor: pointer;"></i>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <span v-if="submitted && errors.has('anneesNaissanceEnfants'+ dt.id)" class="text-danger">
                                    {{ errors.first('anneesNaissanceEnfants'+ dt.id) }}
                                </span>
                            </div>
                        </div>
                    </div>

                    <div class="form-group">
                        <a v-if="isAddAnneeVisible" @click="addAnnee" tabindex="0" v-on:keyup.enter="addAnnee"
                           title="Ajouter une année" style="cursor: pointer;">
                            <i class="fa fa-plus-circle" style="margin-right:5px;cursor: pointer;"></i>Ajouter un enfant</a>
                    </div>
                    <div v-if="this.dossier.datesNaissanceEnfants.length === 5">
                        <span>  <i class="fa fa-info-circle"></i> {{$t('Bareme.etape1.champs.nbMaxEnfants')}}</span>
                    </div>
                </div>


            </div>
        </div>


    </div>

</template>

<script>
import TooltipUtils from '@/utils/TooltipUtils';
import DatePicker from '@/components/commun/DatePicker.vue';

export default {
  name: 'section-questions',
  props: ['dossier', 'submitted', 'listeReference'],
  inject: ['$validator'],
  mixins: [TooltipUtils],
  components: { DatePicker },
  methods: {
    bind(name, id) {
      return `${name}${id}`;
    },
    bindName(id) {
      return `anneesNaissanceEnfants${id}`;
    },
    deleteAnnee(id) {
      if (this.dossier.datesNaissanceEnfants.length > 1) {
        this.dossier.datesNaissanceEnfants = this.dossier.datesNaissanceEnfants.filter(e => e.id !== id);
      }
    },
    addAnnee() {
      this.dossier.datesNaissanceEnfants.push({
        id: this.dossier.datesNaissanceEnfants[this.dossier.datesNaissanceEnfants.length - 1].id + 1,
        dateNaissance: '',
      });
    },
    onChange() {
      if (this.dossier.etatCivil.value === 2) {
        this.dossier.isMarie = true;
        // réinitialiser les champs cachées
        this.dossier.isGardeAlternee = undefined;
        this.dossier.nbEnfants = undefined;
        this.dossier.isUnionLibre = undefined;
        // Si etat civil === marié, faut supprimer les eventuelles erreurs
        // de validation liées au nombre d'enfants
        for (let i = 0; i < 5; i += 1) {
          this.errors.remove(`anneesNaissanceEnfants${i}`);
        }
      } else {
        this.dossier.isMarie = false;
        // réinitialiser les champs cachées
        this.dossier.hasConjointRevenu = undefined;
        this.dossier.sourceRevenu = [];
        this.dossier.isConjointFonctionnaireInt = undefined;
        this.dossier.typeFonctInt = undefined;
      }
      if (this.isCelibataire) {
        this.dossier.dateChangementEtatCivil = undefined;
      }
    },
    onChangeTypeResident() {
      this.$nextTick(() => {
        if (this.dossier.typeResident.value !== 'S') {
          this.dossier.canton = '';
        }
      });
    },
    onChangeHasEnfants() {
      // réinitialiser les champs cachées
      this.dossier.isGardeAlternee = undefined;
      this.dossier.nbEnfants = undefined;
      this.dossier.isUnionLibre = undefined;
    },
  },
  computed: {
    isAddAnneeVisible() {
      const nbEnfants = this.dossier.datesNaissanceEnfants.length;
      if (this.dossier.datesNaissanceEnfants[nbEnfants - 1].dateNaissance != null
                    && this.dossier.datesNaissanceEnfants[nbEnfants - 1].dateNaissance !== undefined
                    && this.dossier.datesNaissanceEnfants[nbEnfants - 1].dateNaissance !== ''
                    && this.dossier.datesNaissanceEnfants[nbEnfants - 1].dateNaissance !== '') { return this.dossier.datesNaissanceEnfants.length < 5; }
      return false;
    },
    isTypeResidentSuisseHorsGeneve() {
      return this.dossier.typeResident && this.dossier.typeResident.value === 'S';
    },
    isAfficherTauxGlobalActivite() {
      return this.dossier.isRevenuUnSeulEmployeur === undefined ? false : !this.dossier.isRevenuUnSeulEmployeur;
    },
    isAfficherDateChangementEtatCivil() {
      return this.dossier.etatCivil && this.dossier.etatCivil.value !== 1;
    },
    isCelibataire() {
      return this.dossier.etatCivil && this.dossier.etatCivil.value === 1;
    },
  },
};
</script>

<style scoped>

    span i.fa-info-circle {
        color: #2c7bb8;
    }
</style>
